import * as React from "react";
const SvgMegaphoneLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20.659 2.06A1 1 0 0 1 22 3v16a1 1 0 0 1-1.341.94L9.824 16H9v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6.824zM11 7.7V14.3l9 3.272V4.427zM9 8H4v6h5zM6 19v-3h1v3z", clipRule: "evenodd" }));
export default SvgMegaphoneLine;
